import { FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

const Error: FC = () => <FormattedMessage id="shared.error" defaultMessage="An error occurred." />;

export default Error;
export { Error };
